import { SessionDescriptionHandler} from "sip.js/lib/platform/web/session-description-handler/session-description-handler";

export class CustomSessionDescriptionHandler extends SessionDescriptionHandler {

  /**
   * Initializes the peer connection event handlers
   */
  initPeerConnectionEventHandlers() {
    this.logger.debug("SessionDescriptionHandler.initPeerConnectionEventHandlers");
    if (!this._peerConnection)
      throw new Error("Peer connection undefined.");
    const peerConnection = this._peerConnection;
    peerConnection.onconnectionstatechange = (event) => {
      var _a;
      const newState = peerConnection.connectionState;
      this.logger.debug(`SessionDescriptionHandler.onconnectionstatechange ${newState}`);
      if ((_a = this._peerConnectionDelegate) === null || _a === void 0 ? void 0 : _a.onconnectionstatechange) {
        this._peerConnectionDelegate.onconnectionstatechange(event);
      }
    };
    peerConnection.ondatachannel = (event) => {
      var _a;
      this.logger.debug(`SessionDescriptionHandler.ondatachannel`);
      this._dataChannel = event.channel;
      if (this.onDataChannel) {
        this.onDataChannel(this._dataChannel);
      }
      if ((_a = this._peerConnectionDelegate) === null || _a === void 0 ? void 0 : _a.ondatachannel) {
        this._peerConnectionDelegate.ondatachannel(event);
      }
    };
    peerConnection.onicecandidate = (event) => {
      var _a;
      this.logger.debug(`SessionDescriptionHandler.onicecandidate`);
      const { candidate } = event;
      if(candidate){
        if(candidate.type === 'srflx'){
          this.iceGatheringComplete();
        }
      }
      if ((_a = this._peerConnectionDelegate) === null || _a === void 0 ? void 0 : _a.onicecandidate) {
        this._peerConnectionDelegate.onicecandidate(event);
      }
    };
    peerConnection.onicecandidateerror = (event) => {
      var _a;
      this.logger.debug(`SessionDescriptionHandler.onicecandidateerror`);
      if ((_a = this._peerConnectionDelegate) === null || _a === void 0 ? void 0 : _a.onicecandidateerror) {
        this._peerConnectionDelegate.onicecandidateerror(event);
      }
    };
    peerConnection.oniceconnectionstatechange = (event) => {
      var _a;
      const newState = peerConnection.iceConnectionState;
      this.logger.debug(`SessionDescriptionHandler.oniceconnectionstatechange ${newState}`);
      if ((_a = this._peerConnectionDelegate) === null || _a === void 0 ? void 0 : _a.oniceconnectionstatechange) {
        this._peerConnectionDelegate.oniceconnectionstatechange(event);
      }
    };
    peerConnection.onicegatheringstatechange = (event) => {
      var _a;
      const newState = peerConnection.iceGatheringState;
      this.logger.debug(`SessionDescriptionHandler.onicegatheringstatechange ${newState}`);
      if (newState === "complete") {
        this.iceGatheringComplete(); // complete waiting for ICE gathering to complete
      }
      if ((_a = this._peerConnectionDelegate) === null || _a === void 0 ? void 0 : _a.onicegatheringstatechange) {
        this._peerConnectionDelegate.onicegatheringstatechange(event);
      }
    };
    peerConnection.onnegotiationneeded = (event) => {
      var _a;
      this.logger.debug(`SessionDescriptionHandler.onnegotiationneeded`);
      if ((_a = this._peerConnectionDelegate) === null || _a === void 0 ? void 0 : _a.onnegotiationneeded) {
        this._peerConnectionDelegate.onnegotiationneeded(event);
      }
    };
    peerConnection.onsignalingstatechange = (event) => {
      var _a;
      const newState = peerConnection.signalingState;
      this.logger.debug(`SessionDescriptionHandler.onsignalingstatechange ${newState}`);
      if ((_a = this._peerConnectionDelegate) === null || _a === void 0 ? void 0 : _a.onsignalingstatechange) {
        this._peerConnectionDelegate.onsignalingstatechange(event);
      }
    };
    peerConnection.onstatsended = (event) => {
      var _a;
      this.logger.debug(`SessionDescriptionHandler.onstatsended`);
      if ((_a = this._peerConnectionDelegate) === null || _a === void 0 ? void 0 : _a.onstatsended) {
        this._peerConnectionDelegate.onstatsended(event);
      }
    };
    peerConnection.ontrack = (event) => {
      var _a;
      const kind = event.track.kind;
      const enabled = event.track.enabled ? "enabled" : "disabled";
      this.logger.debug(`SessionDescriptionHandler.ontrack ${kind} ${enabled}`);
      this.setRemoteTrack(event.track);
      if ((_a = this._peerConnectionDelegate) === null || _a === void 0 ? void 0 : _a.ontrack) {
        this._peerConnectionDelegate.ontrack(event);
      }
    };
  }

}
